import React from "react";

import { Course } from "@examspark/types";

import ResourcesTable from "../../components/resources/ResourcesTable";

const CourseResources = (props: { course?: Course }) => {
  return <ResourcesTable location={props.course} />;
};

export default CourseResources;
